import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import styles from './SectionWork.module.scss';
import { projects } from '@/data/projects';

const SectionWork: React.FC = () => {
  const featured = projects.filter((p) => p.featured).slice(0, 2);

  return (
    <section className={`${styles.workSection} light-section`} id="home-work">
      <div className="torn-edge-top" />
      <div className="container">
        <motion.div
          className={styles.headingWrapper}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className={styles.heading}>SELECTED WORK.</h2>
          <div className="gradient-line"></div>
        </motion.div>

        {featured.length > 0 ? (
          <div className={styles.projectList}>
            {featured.map((project, index) => (
              <motion.div
                key={project.id}
                className={styles.projectBlock}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: index * 0.15 }}
              >
                <Link
                  to={`/work/${project.id}`}
                  className={styles.visualWrapper}
                  aria-label={`View project ${project.title}`}
                >
                  {project.image ? (
                    <div className={styles.visualImageContainer}>
                      <img
                        src={project.image}
                        alt={`${project.title} Mockup`}
                        className={styles.visualImage}
                        loading="lazy"
                      />
                      <div className={styles.visualOverlay} />
                    </div>
                  ) : (
                    <div className={styles.visualPlaceholder}>
                      <div className={styles.visualDotGrid} />
                      <span className={styles.visualLabel}>PROJECT PREVIEW</span>
                    </div>
                  )}
                </Link>
                <div className={styles.projectInfo}>
                  <div className={styles.meta}>
                    <span className={styles.category}>{project.category}</span>
                    <span className={styles.year}>{project.year || '2023'}</span>
                  </div>
                  <h3 className={styles.title}>{project.title}</h3>
                  <p className={styles.description}>{project.description}</p>
                  <div className={styles.techStack}>
                    {project.tags.slice(0, 3).map((tag) => (
                      <span key={tag} className={styles.techTag}>{tag}</span>
                    ))}
                  </div>
                  <Link to={`/work/${project.id}`} className={styles.projectLink}>
                    VIEW PROJECT <ArrowRight size={16} />
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        ) : (
          <motion.div
            className={styles.projectList}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            style={{ textAlign: 'center', padding: '4rem 0' }}
          >
            <p style={{ fontSize: '1.1rem', opacity: 0.6, letterSpacing: '0.05em' }}>
              Selected work is being updated.
            </p>
            <Link to="/contact" className={styles.projectLink} style={{ marginTop: '1.5rem', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
              START A PROJECT <ArrowRight size={16} />
            </Link>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default SectionWork;
